import { bindIndividualDetailsPanel, setIndividualDetailsPanelInfo, showIndividualDetailsPanel } from "../src/rails/individual_details_panel"

let skeletonMain = ""

const VUE_APP_ID = "orders-page-vue-app"

jQuery(document).ready(function () {
  if (!jQuery(".order-history-content").length) return
  const vueEl = document.getElementById(VUE_APP_ID)
  if (vueEl) return

  bindFilterButtonComponent()
  bindOrdersPage()
  bindIndividualDetailsPanel()
})

function bindOrdersPage() {
  createMainLoaderClone()
  bindAddOrderToCart()
  bindDateChangers()
  bindFilterChangeForOrders()
  bindSearch()
  bindSeeMoreButton()
  fetchOrders()
  bindOrdersProgramFilter()
  bindOrdersLocationFilter()
}

function bindOrdersProgramFilter() { 
  $('#orders-program-filter').on('filter:close:change', function () {
    fetchOrders()
  })
}

function bindOrdersLocationFilter() { 
  $('#orders-location-filter').on('filter:close:change', function () {
    fetchOrders()
  })
}

function createMainLoaderClone() {
  skeletonMain = jQuery("#orders-skeleton-loader").clone()
}

function selectedValues(element) {
  const selections = []
  $(element).find('[type=checkbox]:checked').each( function() {
    selections.push($(this).val())
  })
  return selections
}

const createFetchOrders = () => {
  let request = null
  
  const fetchOrders = function(page) {
    if (jQuery(".orders-body").length === 0) return null
    
    const noResultsEl = jQuery(".no-results:visible")
    if (noResultsEl.length > 0) {
      noResultsEl.addClass("d-none")
      jQuery(".orders-header").removeClass("d-none")
      jQuery(".order-history-container").append(skeletonMain)
    }
  
    const skelHidden = jQuery(".skeleton").hasClass("d-none")
    const addSkeleton = !page
  
    if (addSkeleton && skelHidden) {
      jQuery(".skeleton").removeClass("d-none")
      jQuery(".order-row").addClass("d-none")
    }
    const locations = selectedValues($(`#orders-location-filter`).next())
    const programs = selectedValues($(`#orders-program-filter`).next())

    request = jQuery.ajax({
      url: jQuery(".orders-body").data("source"),
      type: "GET",
      data: {
        from: jQuery("#orders_from").val(),
        to: jQuery("#orders_to").val(),
        locations,
        programs,
        search_text: jQuery("#search_filter").val(),
        page: page,
      },
      beforeSend: function () {
        if (request != null) {
          request.abort()
        }
      },
      complete: function () {
        request = null
      },
    })
  }
  return fetchOrders
}

const fetchOrders = createFetchOrders()

function bindDateChangers() {
  jQuery(".order-history-container .date-picker")
    .datepicker()
    .keyup(function (e) {
      if (e.keyCode == 8 || e.keyCode == 46) {
        jQuery.datepicker._clearDate(this)
      }
    })

  jQuery(".order-history-container .date-picker").change(function () {
    fetchOrders()
  })

  bindOrderHistoryMobileDates()
}

function bindOrderHistoryMobileDates() {
  jQuery("#orders_from_mobile").change(function () {
    const $input = jQuery("#orders_from")
    $input.val(jQuery(this).val())
    fetchOrders()
  })

  jQuery("#orders_to_mobile").change(function () {
    const $input = jQuery("#orders_to")
    $input.val(jQuery(this).val())
    fetchOrders()
  })
}

function bindFilterChangeForOrders() {
  jQuery(".filter-bar")
    .off("filter:changed")
    .on("filter:changed", function () {
      fetchOrders()
    })
}

function bindSeeMoreButton() {
  jQuery(".order-history-container").on("click", "#see_more_btn", function () {
    jQuery(this)
      .find(".load-more-text")
      .html('<progress-ring radius="19" progress="0"></progress-ring>')
    jQuery(this).attr("disabled", true)
    animateSeeMoreProgressRing()
    jQuery(".orders-body").removeClass("fadeIn")
    fetchOrders(jQuery(this).data("page"))
  })
}

function animateSeeMoreProgressRing() {
  let progress = 0
  const el = document.querySelector(".load-more-text > progress-ring")
  if (el) {
    setInterval(function () {
      progress += 20
      el.setAttribute("progress", progress)
    }, 150)
  }
}

function bindSearch() {
  jQuery(".order-history-container .orders-search-filter").keyup(function () {
    const $input = jQuery(this)

    delay(function () {
      const searchText = $input.val()
      const previousText = $input.attr("data-previous-search")

      if (searchText !== previousText) {
        $input.attr("data-previous-search", searchText)
        fetchOrders()
      }
    }, 500)
  })
}

function bindAddOrderToCart() {
  jQuery("html").on("click", ".add-order-to-cart", function (e) {
    e.stopImmediatePropagation()
    const $order = jQuery(this)

    jQuery.ajax({
      url: $order.data("source"),
      type: "POST",
    })
  })
}

function initWindowTooltips() {
  jQuery(".window-tooltip").tooltip({
    container: ".order-history-container",
  })
}

window.initWindowTooltips = initWindowTooltips
window.showIndividualDetailsPanel = showIndividualDetailsPanel
window.bindIndividualDetailsPanel = bindIndividualDetailsPanel
window.setIndividualDetailsPanelInfo = setIndividualDetailsPanelInfo
window.bindOrdersPage = bindOrdersPage
